"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CookieJar = function () {
  function CookieJar() {
    throw new TypeError('Cookie jars are not available in browsers');
  }
  return CookieJar;
}();
exports.CookieJar = CookieJar;